import { API_RESPONSE_ERROR_TEXT } from '../../constants/errors'
import { ERROR_TEXT } from '../../constants/messages'
import { toLower } from '../string.helpers'

const cleanupXUsername = (str) => {
  return toLower(str?.startsWith('@') ? str?.slice(1) : str)
}

const extractInitials = (firstName, lastName) => {
  return firstName && lastName && `${firstName[0] || ''}${lastName[0] || ''}`
}

const buildConnectXError = (message) => {
  if (message === API_RESPONSE_ERROR_TEXT.ACCESS_DENIED) {
    return 'earn-via.rejected-auth-request'
  }
  return message || ERROR_TEXT.SOMETHING_WENT_WRONG
}

export { buildConnectXError, cleanupXUsername, extractInitials }
